import { PointOfSale } from "@m4a3/api-client";
import { RootState } from "../store/configureStore";

export const selectPointOfSales = (state: RootState): PointOfSale[] => state.admin.pointOfSales;
